export type OrderStatusMessages = {
  confirmed: string;
  paid: string;
  handling: string;
  invoiced: string;
  shipped: string;
  delivered: string;
  waiting: string;
  cancelled: string;
  error: string;
  cancellationRequest: string;
};

export const ORDER_STATUS_MESSAGES: OrderStatusMessages = {
  confirmed: "Aguardando Pagamento",
  paid: "Pago",
  handling: "Em manuseio",
  invoiced: "Faturado",
  shipped: "Enviado",
  delivered: "Entregue",
  waiting: "Orçamento",
  cancelled: "Cancelado",
  error: "Erro",
  cancellationRequest: "Cancelamento Solicitado",
};
